export default {
  insurancePolicies: 'Insurance Policies',
  insuranceCustomers: 'Insurance Customers',
  insuranceCompanies: 'Insurance Companies',
  settings: 'Settings'
}
